module.exports = __webpack_public_path__ + "img/TRAVEL-EN.81423c66.jpg";